import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { axios } from '../../../../../../utils/axios';
import { showAlert } from '../../../../../../utils/alerts';

import PIRTable from './table';

const PIRSetup = ({ setLogsModal, pirData, refreshPIR, parentLoading }) => {
  const { crNumber } = useParams();
  const [loading, setLoading] = useState(false);

  // Retry handler (calls backend postPirData)
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        costing_request_id: crNumber,
      };

      const response = await axios.post(`/costing-request/pir_data/${crNumber}`, payload);

      if (response.status === 200 && response.data.success === true) {
        showAlert({ message: `PIR Setup successfully refreshed for SKU ` }, 'success');

        if (refreshPIR) await refreshPIR();
      } else {
        throw new Error(response.data.message || 'PIR refresh failed. Please check logs.');
      }
    } catch (error) {
      showAlert({ message: `PIR refresh failed for SKU . Please check logs.` }, 'error');

      console.error('Error during PIR refresh:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch logs
  const fetchLogs = useCallback(async () => {
    try {
      const response = await axios.get(`/costing-request/pir_setup_logs/${crNumber}`);
      if (response.status !== 200) throw new Error('Failed to fetch PIR logs');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching PIR logs:', error);
      throw error;
    }
  }, [crNumber]);

  return (
    <PIRTable
      handleSubmit={handleSubmit}
      data={(pirData?.data || []).map((item) => {
        return {
          ...item,
          interco_markup_out_perf_in_cognos: item.interco_markup_out_perf,
        };
      })}
      status={pirData.status}
      loading={loading || parentLoading}
      setLogsModal={setLogsModal}
      fetchLogs={fetchLogs}
    />
  );
};

export default PIRSetup;
